<div [ngClass]="[mode == 'builder'?'chart-wrapper-builder':'chart-wrapper']" class="white-bg border-light margin">
    <ng-container *ngIf="isProgress">
        <mat-spinner class="spinner" diameter=20></mat-spinner>
    </ng-container>
    <ng-container *ngIf="!isProgress && !errorhandledashboardwidget.status">
        <div class="chart-card" [ngStyle]="bgColor">
            <h1 class=" data bold-text pr-6">{{_data.style?.compact?.mode === 'auto' ? _data?.widgetdata.headers?.[0]?.type === 'size' ? getFormattedSize(labelData) : getFormattedValue(labelData) : _data.style.compact?.type === 'number' ? getFormattedValue(labelData) : getFormattedSize(labelData)}}</h1>
            <p class="  title content-l pr-6">{{title}}</p>
        </div>
    </ng-container>
    <ng-container *ngIf="!isProgress && errorhandledashboardwidget.status">
        <div class="dashboardwidget-nodata">
            <div class="nodata-img">
                <img src="assets/widgets/empty-data.svg" />
            </div>
            <div>
                <p class="m-0 content-s secondary-text no-result">{{errorhandledashboardwidget.errmsg}}</p>
            </div>
        </div>
    </ng-container>
</div>